import UserSidebar from "./Components/UserSidebar";
import React, { useState, useEffect } from "react";
import NFTMarketplace from "../artifacts/contracts/NFTMarketplace.sol/NFTMarketplace.json";
import nftmarketaddress from "../config";
import { ethers } from "ethers";
import axios from "axios";
import Web3Modal from "web3modal";
import Modal from "react-bootstrap/Modal";
import { AiOutlineLike, AiFillLike } from 'react-icons/ai';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {TestBAlert} from './Components/TestBAlert'
const HomeFeatured = () => {
    const [nfts, setNfts] = useState([]);
    const [selectedNft, setSelectedNft] = useState(null);
    const [loadingState, setLoadingState] = useState("not-loaded");
    const [showModal, setShowModal] = useState(false);

    const handleShowModal = (nft) => {
        setSelectedNft(nft);
        setShowModal(true);
    };

    const handleCloseModal = () => setShowModal(false);

    useEffect(() => {
        loadNFTs();
    }, []);

    function ncard(val) {
        // function formatAddress(address) {
        //     return `${address.slice(0, 3)}...${address.slice(-4)}`;
        // }

        const isWalletConnected = !!JSON.parse(localStorage.getItem("wAddressLocal"));

        return (
            <div className="home-featured col-md-3 mb-4">
                <div className="card">
                    <img
                        src={val.image}
                        alt=""
                        className="rounded"
                        style={{ width: '250px', height: '250px'}}
                        onClick={() => handleShowModal(val)}
                    />



                    <div className="card-body">
                        <h5 className="card-title">{val.name}</h5>
                        <p className="card-text">{val.price} MATIC</p>
                        {/* <p className="card-text">Owner: {formatAddress(val.owner)}</p>
                        <p className="card-text">Seller: {formatAddress(val.seller)}</p> */}
                        {!isWalletConnected ? (
                            <p>Connect wallet to see more details</p>
                        ) : (
                            <>
                            <button
                                type="button"
                                className="btn btn-outline-success me-2 mt-2"
                                onClick={() => buyNft(val)}
                            >
                                Buy
                            </button>

<button className="btn btn-info me-2 mt-2" onClick={() => likeNft(val)} style={{ cursor: "pointer" }}>
  {val.totalLikes} <AiOutlineLike />
</button>

</>

                        )}
                        


                    </div>
                </div>

                <Modal show={showModal} onHide={handleCloseModal}>
                    <Modal.Body>
                        {selectedNft && <img src={selectedNft.image} alt="" className="img-fluid" />}
                    </Modal.Body>
                </Modal>
            </div>
        );
    }

    async function loadNFTs() {
        const response = await axios.get("https://mint-blocks-api-production.up.railway.app/api/nftsApproved");

        const items = response.data.map((item) => ({
            price: item.price,
            tokenId: item.tokenId.toString(),
            seller: item.sellerAddress,
            owner: item.ownerAddress,
            image: item.fileUrl,
            name: item.name,
            description: item.description,
            isApproved: item.isApproved,
            totalLikes: item.totalLikes
        }));

        setNfts(items);
        setLoadingState("loaded");
    }
    async function likeNft(nft) {
        console.log("Like", nft.tokenId, JSON.stringify(wAddressLocalget))
        try {

          const response = await axios.post("https://mint-blocks-api-production.up.railway.app/api/like", {
            tokenId: nft.tokenId,
            sellerAddress: JSON.stringify(wAddressLocalget)
          });
          const { likes } = response.data;
          console.log("Likes:", likes);
         
          loadNFTs();
          
        } catch (error) {
          console.error(error);
          toast.error("An error occured while liking this NFT, please try again later")
        }
      }
    async function buyNft(nft) {

        const provider = new ethers.providers.Web3Provider(window.ethereum);
        const signer = provider.getSigner();
        const contract = new ethers.Contract(nftmarketaddress, NFTMarketplace.abi, signer);

        try {
            toast.info("Connecting to MetaMask, please wait")
            const price = ethers.utils.parseUnits(nft.price.toString(), "ether");
            const transaction = await contract.createMarketSale(nft.tokenId, {
                value: price,
            });
            toast.info("Your transaction is processing please wait")
            await transaction.wait();
            toast.success("You have successfully purchased an NFT, go to Assets page to view")
            // Query the database to find the NFT with the matching tokenId
            const response = await axios.get(`https://mint-blocks-api-production.up.railway.app/api/nftsByTokenId/${Number(nft.tokenId)}`);
            console.log(response.data);

            // Send the NFT data to the assets collection API
            const assetData = {
                tokenId: response.data.tokenId,
                name: response.data.name,
                description: response.data.description,
                fileUrl: response.data.fileUrl,
                price: response.data.price,
                ownerAddress: response.data.ownerAddress,
                sellerAddress: response.data.sellerAddress,
                productLikes: response.data.productLikes
            };

            const response2 = await axios.post("https://mint-blocks-api-production.up.railway.app/assets", assetData);
            console.log("Response from the server:", response2.data);

            // Delete the NFT from the database
            await axios.delete(`https://mint-blocks-api-production.up.railway.app/api/nftsDelTokenId/${nft.tokenId}`);

            // Reload the list of NFTs after deletion
            loadNFTs();
        } catch (error) {
            console.error(error);
            toast.error("Make sure you have enough balance or try again later")
        }
    }

    let wAddressLocalget = JSON.parse(localStorage.getItem("wAddressLocal"));

    return (
        <div className="container">
               
            <div className="container">
          
                <h2 className="featured-collection-main-title">Featured <b>NFTs</b></h2>
                <TestBAlert/>
                <div className="row">
                    {nfts.length === 0 ? (
                        <p>No NFTs to display.</p>
                    ) : (
                        nfts.map(ncard)
                    )}
                </div>
            </div>
            <ToastContainer position="top-right" />
        </div>
    );
};

export default HomeFeatured;
